var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSerIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.9335 10.2805L23.7468 10.1738L21.8935 9.10712L18.0668 6.89379C16.8935 6.21379 15.1068 6.21379 13.9335 6.89379L10.1068 9.10712L8.25346 10.1871L8.01346 10.3205C5.6268 11.9205 5.4668 12.2138 5.4668 14.7871V20.9338C5.4668 23.5071 5.6268 23.8005 8.0668 25.4405L13.9335 28.8271C14.5201 29.1738 15.2535 29.3338 16.0001 29.3338C16.7335 29.3338 17.4801 29.1738 18.0668 28.8271L23.9868 25.4005C26.3735 23.8005 26.5335 23.5071 26.5335 20.9338V14.7871C26.5335 12.2138 26.3735 11.9205 23.9335 10.2805Z",
    fill: "#090129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25391 10.187L10.1072 9.10699L13.7606 7.00033L13.9339 6.89366C15.1072 6.21366 16.8939 6.21366 18.0672 6.89366L18.2406 7.00033L21.8939 9.10699L23.7472 10.1737V7.32032C23.7472 4.32033 22.0939 2.66699 19.0939 2.66699H12.8939C9.89391 2.66699 8.25391 4.32033 8.25391 7.32032V10.187Z",
    fill: "#090129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7876 17.787L18.961 18.8004C18.8276 18.947 18.7343 19.2404 18.7476 19.4404L18.8276 20.747C18.881 21.547 18.3076 21.9604 17.561 21.667L16.3476 21.187C16.161 21.1204 15.841 21.1204 15.6543 21.187L14.441 21.667C13.6943 21.9604 13.121 21.547 13.1743 20.747L13.2543 19.4404C13.2676 19.2404 13.1743 18.947 13.041 18.8004L12.2143 17.787C11.6943 17.1737 11.921 16.4937 12.6943 16.2937L13.961 15.9737C14.161 15.9204 14.401 15.7337 14.5076 15.5604L15.2143 14.467C15.6543 13.787 16.3476 13.787 16.7876 14.467L17.4943 15.5604C17.601 15.7337 17.841 15.9204 18.041 15.9737L19.3076 16.2937C20.081 16.4937 20.3076 17.1737 19.7876 17.787Z",
    fill: "#090129"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerIcon4);
export default __webpack_public_path__ + "static/media/ser-icon-4.77e54b6ab9dadaba23970352eb8fdf43.svg";
export { ForwardRef as ReactComponent };